import axios from 'axios'

export const AdminAdoptionStatusService = {
  /**
   * @param {*} status blank is for both status(published and inactive)
   * status = 1 ==> for inactive
   * status = 2 ==> for published
   */
  fetchAdoptionStatusList (status = '') {
    if (status !== '') {
      return axios.get(`/api/v1/adopstatuslist/${status}`)
    } else {
      return axios.get('/api/v1/adopstatuslist')
    }
  }
}
